export default __webpack_public_path__ + "static/media/solucao-07.7d4b3861.webp";